import { Form } from 'react-bootstrap';
import Select from "react-select";
import './SubscriptionForm.scss'
import { ISelectOptions } from 'aw-combobox';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const SubscriptionForm = (props: {
    onChangeCountry: (e: ISelectOptions) => void, countryOptions: ISelectOptions[],
    onChangeConnection: (e: ISelectOptions) => void, connectionOptions: ISelectOptions[],
    onCheckedDocument1: (e: any) => void, onCheckedDocument2: (e: any) => void
}) => {

    const { t } = useTranslation();


    return (
        <>
            <div>
                <Form.Label className='mb-0'>{t('Country')}</Form.Label>
                <div className="col">
                    <Select className='w-100 me-2' closeMenuOnSelect={true} onChange={(e) => props.onChangeCountry(e as ISelectOptions)} defaultValue={undefined} options={props.countryOptions} />
                </div>
            </div>
            <div className="mt-2">
                <Form.Label className='mb-0'>{t('SimRequired')}</Form.Label>
                <div className="col">
                    <Select className='w-100 me-2' closeMenuOnSelect={true} onChange={(e) => props.onChangeConnection(e as ISelectOptions)} defaultValue={undefined} options={props.connectionOptions} />
                </div>
            </div>
            <div className="mt-2">
                <CheckWithPDF urlDoc="" nameDoc={t('DataProtect')} onCheked={props.onCheckedDocument1} />

            </div>
            <div className="mt-2">
                <CheckWithPDF urlDoc="" nameDoc={t('UsageContract')} onCheked={props.onCheckedDocument2} />
            </div>
        </>
    );
}


export const CheckWithPDF = (props: { urlDoc: string, nameDoc: string, onCheked: (e: any) => void }) => {
    const [pdfOpened, setPdfOpened] = useState(true);
    const { t } = useTranslation();
    const handleOpenPdf = () => {
        // window.open(props.urlDoc, "_blank");
        setPdfOpened(true);
    };

    return (
        <div>
            <span>
                {t('OpenAndRead')}{" "}
                <a href="#" onClick={handleOpenPdf}>
                    {props.nameDoc}
                </a>
            </span>

            <Form.Check
                name="active"
                type="checkbox"
                label={`${t('IReadAndAccept')} ${props.nameDoc}`}
                defaultChecked={false}
                disabled={!pdfOpened}
                onClick={(e) => props.onCheked(e)}
            />
        </div>
    );
};


export default SubscriptionForm;